import React from 'react'

const HamburgerMenu = ({overlayVisibility, sliderDisplay, ...props}) => {
  return (
    <div
      // className={`${display} flex flex-col fixed -bottom-4 right-0 z-10 bg-blue-500 transition-all ease-in duration-100`}
      className={`${overlayVisibility} flex flex-col fixed z-30 right-0 top-0 h-full w-full bg-black/20`}
    >
      <div
        className={`${sliderDisplay} absolute transition-all z-40 ease-out duration-200 top-16 right-0 h-auto bg-stone-200 shadow-md rounded-l-xl`}
      >
        <div className='m-auto'>
          <div className='w-60 py-6 px-3'>{props.children}</div>
        </div>
      </div>
    </div>
  )
}

export default HamburgerMenu
